import type { KehrblattPlanningSettings } from "../../../../../../../../../api/kehrblatt/planning"

export type CalendarPlanningSettingsView = {
  flexSlotMinutes: number
  flexSlotsPerDay: number
}

export const normalizeCalendarPlanningSettings = (
  settings?: KehrblattPlanningSettings | null,
  slotMinutes = 5,
): CalendarPlanningSettingsView => {
  const flexMinutes = Number(settings?.flex_slot_minutes ?? 60)
  const flexSlots = Number(settings?.flex_slots_per_day ?? 0)

  return {
    flexSlotMinutes: Number.isFinite(flexMinutes)
      ? Math.ceil(Math.max(1, flexMinutes) / slotMinutes) * slotMinutes
      : 60,
    flexSlotsPerDay: Number.isFinite(flexSlots) ? Math.max(0, Math.floor(flexSlots)) : 0,
  }
}
